import { useCallback, useEffect } from 'react'
import { useParams } from 'react-router'
import { Onboardings } from '@/core/enums/onboardings'
import { useOnboarding } from '@/core/hooks/use-onboarding'
import { stepsSecondPage } from '../components/steps'

export const useUsuarioEdicaoSecondPageOnboarding = () => {
  const {
    currentUserOnboardingIsSeen,
    setSteps,
    setOpen,
    loading,
    save,
    setCurrentStep
  } = useOnboarding(Onboardings.USUARIO_EDICAO_SECOND_PAGE)
  const params = useParams()

  const setNextStepAndOpen = useCallback(() => {
    if (params.id || currentUserOnboardingIsSeen) return
    setCurrentStep(0)
    setSteps?.([stepsSecondPage(save)[1]])
    setOpen()
  }, [params.id, setSteps, save, setOpen, currentUserOnboardingIsSeen])

  useEffect(() => {
    if (!currentUserOnboardingIsSeen && !loading) {
      // se o usuario estiver editando um usuario existente e não fez o onboarding ainda, carrega todos os steps
      // caso contrario carrega apenas o primeiro, o segundo será carregado dinamicamente ao selecionar opções
      setCurrentStep(0)
      if (params.id) {
        setSteps?.(stepsSecondPage(save))
      } else {
        setSteps?.([stepsSecondPage()[0]])
      }
      setOpen()
    }
  }, [
    currentUserOnboardingIsSeen,
    loading,
    params.id,
    save,
    setOpen,
    setSteps,
    setCurrentStep
  ])

  return { setNextStepAndOpen }
}
